// extracted by mini-css-extract-plugin
export default {"type1":"stampUp_type1__17FPS","slidein":"stampUp_slidein__N4WJA"};